export enum RestaurantTypes {
  RESTAURANT = 0,
  TERIYAKI = 1,
  TAMASHI = 2,
  ZENKITCHEN = 3
}
